import DevelopmentClientDetailContainer from './containers/DevelopmentClientDetailContainer'

export default DevelopmentClientDetailContainer
